type FlightFareCardSectionProps = {
  title: string;
  children: React.ReactNode;
};

export function FlightFareCardSection({
  title,
  children,
}: FlightFareCardSectionProps) {
  return (
    <div className="flex flex-col gap-2">
      <h3 className="text-base font-medium text-text-primary">{title}</h3>

      <div className="flex flex-col gap-2">{children}</div>
    </div>
  );
}

type FlightFareCardSectionItemProps = {
  label: React.ReactNode;
  description?: string;
  icon: React.ReactNode;
  suffix?: string;
};

export function FlightFareCardSectionItem({
  label,
  description,
  icon,
  suffix,
}: FlightFareCardSectionItemProps) {
  return (
    <div className="flex items-center gap-1">
      {icon}

      <div className="flex grow flex-col gap-0.5">
        <span className="text-sm text-text-primary">{label}</span>

        {description && (
          <span className="text-sm text-text-tertiary">{description}</span>
        )}
      </div>

      {suffix && <span className="text-sm text-text-tertiary">{suffix}</span>}
    </div>
  );
}
